import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=69542320&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"
import style0 from "./recommend.vue?vue&type=style&index=0&id=69542320&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69542320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69542320')) {
      api.createRecord('69542320', component.options)
    } else {
      api.reload('69542320', component.options)
    }
    module.hot.accept("./recommend.vue?vue&type=template&id=69542320&scoped=true", function () {
      api.rerender('69542320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/recommend.vue"
export default component.exports